<template>
    <label class="RPCheckbox">
        <input
            type="checkbox"
            :value="value"
            class="RPCheckbox__input"
            :indeterminate="indeterminate"
            :disabled="disabled"
            @keypress.enter.stop="clickAction"
            @click.stop="clickAction"
        >
        <button :class="buttonClass">
            <StreamlineIcon
                v-if="value || indeterminate"
                class="RPCheckbox__button-icon"
                :icon="icon"
                :size="12"
                :fill="white"
                :stroke="white"
            />
        </button>
        <span
            v-if="label !==''"
            class="RPCheckbox__label"
        >
            {{ label }}
        </span>
    </label>
</template>

<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {Check} from "@reviewpush/streamline-bold/lib/interface-essential/FormValidation";
import {Subtract} from "@reviewpush/streamline-bold/lib/interface-essential/RemoveAdd";
import {white} from "style/_colors.scss";
import statusBuilder from "status/statusBuilder";
import stat from "status";

export default {
    components: {
        StreamlineIcon
    },
    props: {
        /**
       * @model
       */
        value: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            default: ""
        },
        /**
       * When true, the checkbox will display a dash icon, to indicate that it has
       * some child inputs that are checked and some that are unchecked
       */
        indeterminate: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            white,
        };
    },
    computed: {
        buttonClass() {
            return statusBuilder("RPCheckbox__button",
                stat.STANDBY,
                this.disabled,
                {
                    indeterminate: this.indeterminate && !this.value,
                    checked: this.value,
                }
            );
        },
        icon() {
            return this.value ? Check : Subtract;
        },
    },
    methods: {
        clickAction() {
            if (this.indeterminat && !this.value) {
                this.$emit('indeterminate');
            }
            this.$emit("input", !this.value);
        },
    }
};
</script>

<style lang="scss" scoped>
.RPCheckbox {
    position: relative;
    display: flex;
    width: fit-content;
    white-space: nowrap;
    cursor: pointer;

    &__input {
        position: absolute;
        height: 1rem;
        width: 1rem;
        opacity: 0;
        border-radius: 4px;
        cursor: pointer;
    }

    &__button {
      height: 1rem;
      width: 1rem;
      border-radius: 4px;
      padding: 0;
      border: 1px solid $grey;
      background: $white;
      &--checked {
        border-color: $primary;
        background: $primary;
      }
      &--indeterminate{
        background: $primary-200;
        border-color: $primary-200;
      }
      &--disabled {
        cursor: auto;
        border-color: $grey-200;
        background: $grey-100;
      }

      &-icon {
        display: block;
      }
    }

    &__label {
        margin-left: 0.25rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: $text-grey;
    }
}
</style>

<docs>
Basic example:
```[import](./CheckboxExample.vue)
```
</docs>
